import { render, staticRenderFns } from "./BirthdayCardText.vue?vue&type=template&id=5a888029&scoped=true"
import script from "./BirthdayCardText.vue?vue&type=script&lang=js"
export * from "./BirthdayCardText.vue?vue&type=script&lang=js"
import style0 from "./BirthdayCardText.vue?vue&type=style&index=0&id=5a888029&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a888029",
  null
  
)

export default component.exports